// extracted by mini-css-extract-plugin
module.exports = {"text":"onfido-sdk-ui-Welcome-text"};